import {useCallback} from 'react';
import {useDispatch} from 'react-redux';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {getAccessRightProfile} from 'src/openapi/admin/apis/GetAccessRightProfileApi';

import type {ApiDispatchForToolkit} from 'src/openapi/admin/types';

type Props = {
    profileId: number,
};

export const useGetRoleProfile = ({profileId}: Props) => {
    const apiDispatch = useDispatch<ApiDispatchForToolkit>();

    const getDispatchAction = useCallback(() => apiDispatch(
        getAccessRightProfile({profileId}),
    ), [apiDispatch, profileId]);

    return useReadOnlyDataHook({
        initValue: {
            profileId: -1,
            profileName: '',
            usersCounts: 0,
            isPrimary: false,
            rightsCodes: [],
        },
        getDispatchAction,
    });
};
